'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n'], ['\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: 300px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n  margin: auto;\n'], ['\n  width: 300px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n  margin: auto;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  width: 600px;\n  margin: 50px auto;\n\theight: 200px;\n  display: contents;\n'], ['\n  width: 600px;\n  margin: 50px auto;\n\theight: 200px;\n  display: contents;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  width: 100%;\n  margin: 10px auto;\n\ttext-align: center;\n'], ['\n  width: 100%;\n  margin: 10px auto;\n\ttext-align: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _MozartRadio = require('../MozartInputBox/MozartRadio');

var _MozartRadio2 = _interopRequireDefault(_MozartRadio);

var _MozartModal = require('../MozartDialog/MozartModal');

var _MozartModal2 = _interopRequireDefault(_MozartModal);

var _MozartSelectField = require('../MozartDropDown/MozartSelectField');

var _MozartSelectField2 = _interopRequireDefault(_MozartSelectField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MozartOLSContainer = _styledComponents2.default.div(_templateObject);
var MozartOLSTypeContainer = _styledComponents2.default.div(_templateObject2);
var MozartOLSListContainer = _styledComponents2.default.div(_templateObject3);
var MozartOLSListLabel = _styledComponents2.default.div(_templateObject4);

var MozartOLS = function (_Component) {
  _inherits(MozartOLS, _Component);

  function MozartOLS(props) {
    _classCallCheck(this, MozartOLS);

    var _this = _possibleConstructorReturn(this, (MozartOLS.__proto__ || Object.getPrototypeOf(MozartOLS)).call(this, props));

    _this.state = {
      currentList: _this.props.selectedList && _this.props.selectedList[0] === '*' ? [] : _this.props.selectedList,
      isOpen: _this.props.isOpen,
      selectedType: _this.props.selectedList && _this.props.selectedList[0] === '*' ? '*' : '#'
    };
    return _this;
  }

  _createClass(MozartOLS, [{
    key: 'setCurrentList',
    value: function setCurrentList(data) {
      var list = [];
      if (data.length) {
        list = data.map(function (item) {
          return item.value;
        });
      }
      this.setState({ currentList: list });
    }
  }, {
    key: 'submitForm',
    value: function submitForm() {
      var _this2 = this;

      var handleSubmit = this.props.handleSubmit;

      this.setState({
        isOpen: false
      }, function () {
        if (handleSubmit) {
          handleSubmit(_this2.state.selectedType === '*' ? ['*'] : _this2.state.currentList);
        }
      });
    }
  }, {
    key: 'setUserListType',
    value: function setUserListType(type) {
      this.setState({
        selectedType: type
      });
    }
  }, {
    key: 'toggleModal',
    value: function toggleModal() {
      var _this3 = this;

      this.setState({
        isOpen: !this.state.isOpen
      }, function () {
        if (_this3.props.handleClose) {
          _this3.props.handleClose();
        }
      });
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      var _this4 = this;

      return _react2.default.createElement(
        MozartOLSContainer,
        null,
        _react2.default.createElement(
          MozartOLSTypeContainer,
          null,
          _react2.default.createElement(
            _MozartRadio2.default,
            { border: true, style: { width: '140px' } },
            _react2.default.createElement('input', {
              type: 'radio',
              id: 'radio_everyone',
              name: 'ols_type',
              checked: this.state.selectedType === '*',
              onChange: this.setUserListType.bind(this, '*')
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: 'radio_everyone', title: 'Everyone' },
              'Everyone'
            )
          ),
          _react2.default.createElement(
            _MozartRadio2.default,
            { border: true, style: { width: '140px' } },
            _react2.default.createElement('input', {
              type: 'radio',
              id: 'radio_specific_users',
              name: 'ols_type',
              onChange: this.setUserListType.bind(this, '#'),
              checked: this.state.selectedType === '#'
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: 'radio_specific_users', title: 'Specific Users' },
              'Specific Users'
            )
          )
        ),
        this.state.selectedType === '#' && _react2.default.createElement(
          MozartOLSListContainer,
          null,
          _react2.default.createElement(
            MozartOLSListLabel,
            null,
            'Start adding user(s) by typing the name'
          ),
          _react2.default.createElement(_MozartSelectField2.default, {
            data: this.props.dataList,
            defaultValue: this.state.currentList,
            key: this.state.currentList.join(),
            multiselect: true,
            disabled: this.state.selectedType === '*',
            onChange: function onChange(data) {
              return _this4.setCurrentList(data);
            } })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          id = _props.id,
          testId = _props.testId,
          disableSubmit = _props.disableSubmit,
          submitLabel = _props.submitLabel,
          width = _props.width,
          themeId = _props.themeId;

      return _react2.default.createElement(
        'div',
        { 'data-qa': this.props.testId, 'data-theme': themeId },
        _react2.default.createElement(
          _MozartModal2.default,
          {
            show: this.state.isOpen,
            onClose: this.toggleModal.bind(this),
            title: title,
            id: id ? id : testId,
            submitLabel: submitLabel,
            handleSubmit: this.submitForm.bind(this),
            width: width,
            disableSubmit: disableSubmit || this.state.selectedType === '#' && this.state.currentList.length === 0
          },
          this.getContent()
        )
      );
    }
  }]);

  return MozartOLS;
}(_react.Component);

MozartOLS.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** id attribute */
  id: _propTypes2.default.string,
  /** title of the dialog */
  title: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  /** Submit button label */
  submitLabel: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
  /** custom width */
  width: _propTypes2.default.string,
  /** hide submit button */
  disableSubmit: _propTypes2.default.bool,
  /** show popUp */
  isOpen: _propTypes2.default.bool,
  /** callback when submit clicked */
  handleSubmit: _propTypes2.default.func,
  /** callback when closed */
  handleClose: _propTypes2.default.func,
  /** List of items to select from */
  dataList: _propTypes2.default.array,
  /** List of selected items */
  selectedList: _propTypes2.default.array
};
MozartOLS.defaultProps = {
  testId: 'MozartOLS',
  themeId: 'MozartOLS',
  title: 'Permission',
  submitLabel: 'Set Permission',
  width: '700px',
  selectedList: [1, 2],
  disableSubmit: false,
  isOpen: false,
  dataList: []
};
exports.default = MozartOLS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartOLS/MozartOLS.js
// module id = 2118
// module chunks = 1